const es = {
  layout: {
    cos_button: {
      phone: 'Teléfono',
      update_phone_number_message: 'El número de teléfono se actualizó correctamente!'
    },
    time: {
      days: 'Días',
      hours: 'Horas',
      mins: 'Min',
      secs: 'Seg',
      starts: 'Comenzará',
      starts_immediately: 'Comenzará de inmediato'
    },
    field: {
      host: 'Anfitrión'
    },
    copy: 'Copiar'
  },
  validations: {
    email: 'debe ser un correo electrónico válido',
    phone: 'no es válido',
    required_field: 'es un campo requerido'
  },
  mailer: {
    need_help: '¿Necesitas ayuda?',
    stop_reminders: 'Dejar de recibir recordatorios',
    cancel_registration: 'Cancelar registro',
    report_abuse: 'Denunciar abuso'
  },
  datetime: {
    no_sessions: 'No hay sesiones disponibles',
    empty_label: 'Fecha/Hora'
  },
  errors: {
    verification_failed: 'La verificación ha fallado. Por favor, inténtelo de nuevo.',
    session_unavailable: 'La hora que seleccionaste ya no está disponible. Por favor, elige otro horario.',
    challenge_email_mismatch: 'Regístrate con el mismo correo electrónico que usaste para registrarte en el evento.'
  }
}

export default es
